import React from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import fields from '../../../../constants/fields.const';
import Icon from '../../../@shared/icon';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import { EditFrameComponent } from '../../../@shared/editFrame';
import { TSocialMediaProps } from '../../types/socialMedia.types';
import { SocialMediaModel } from '../../models/socialMedia.model';
import { TSitecoreContext } from '../../../../types/types';

const SocialMedia = (props: TSocialMediaProps): JSX.Element => {
  const model = new SocialMediaModel(props);
  const isEEactive = props?.sitecoreContext?.pageEditing;

  return (
    <div className="light-footer-social-media">
      {model.socialLinks?.map((item) => {
        return (
          <div key={item.id} className="light-footer-social-media__social-icon-link-wrapper">
            {isEEactive ? (
              <>
                <CustomExternalAnchor
                  field={item?.fields?.link}
                  key={item.id}
                  className={'social-media-section__social-icon-link'}
                  target="_blank"
                />
                <EditFrameComponent itemId={item.id} fields={[fields.icon]} sitecoreContext={props?.sitecoreContext as TSitecoreContext}>
                  <Icon iconField={item?.fields?.icon} size={iconSize.mbl} color="primary" />
                </EditFrameComponent>
              </>
            ) : (
              <CustomExternalAnchor
                field={item?.fields?.link}
                key={item.id}
                className={'social-media-section__social-icon-link'}
                target="_blank"
              >
                <Icon iconField={item?.fields?.icon} size={iconSize.dsk} color="primary" />
              </CustomExternalAnchor>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SocialMedia;
